import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Step0 from './pages/Step0';
import Step1 from './pages/Step1';
import Step2 from './pages/Step2';
import Step3 from './pages/Step3';
import Step4 from './pages/Step4';
import Step5 from './pages/Step5';
import Step6 from './pages/Step6';
import MedicalDeclaration from './pages/MedicalDeclaration';
import InvestmentValidation from './pages/InvestmentValidation';
import Congratulation from './pages/Congratulation';
import Payement from './pages/Payement';

function App() {
  return (
    <>
      <Header />
      <main className="overflow-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/step-0" element={<Step0 />} />
          <Route path="/step-1" element={<Step1 />} />
          <Route path="/step-2" element={<Step2 />} />
          <Route path="/step-3" element={<Step3 />} />
          <Route path="/step-4" element={<Step4 />} />
          <Route path="/step-5" element={<Step5 />} />
          <Route path="/step-6" element={<Step6 />} />
          <Route path="/medical-declaration" element={<MedicalDeclaration />} />
          <Route path="/investment-validation" element={<InvestmentValidation />} />
          <Route path="/congratulation" element={<Congratulation />} />
          <Route path="/payment" element={<Payement />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;